export default class FixedBlock {
    static init(): void {
        // Sticky scroll efekt pro cart summary
        class StickyCartSummary {
            private cartSummary: HTMLElement | null;
            private cartFlex: HTMLElement | null;
            private cartColRight: HTMLElement | null;
            private navbar: HTMLElement | null;
            private lastScrollTop: number;
            private scrollDirection: 'up' | 'down';

            constructor() {
                this.cartSummary = document.querySelector('.js-fixed-block-item');
                this.cartFlex = document.querySelector('.js-fixed-block-section');
                this.cartColRight = document.querySelector('.js-fixed-block-col');
                this.navbar = document.querySelector('.base-navbar');

                // Pro detekci směru scrollování
                this.lastScrollTop = 0;
                this.scrollDirection = 'down';

                if (!this.cartSummary || !this.cartFlex || !this.cartColRight) {
                    //console.warn('Požadované elementy nebyly nalezeny');
                    return;
                }

                this.init();
            }

            private init(): void {
                // Poslouchej scroll a resize
                window.addEventListener('scroll', () => this.handleScroll());
                window.addEventListener('resize', () => this.updateDimensions());

                // Počáteční nastavení
                this.updateDimensions();
            }

            private getNavbarHeight(): number {
                if (!this.navbar) return 0;
                return this.navbar.offsetHeight;
            }

            private updateDimensions(): void {
                // Aktualizuj rozměry a pozice při resize
                this.updateFixedStyles();
                this.handleScroll();
            }

            private updateFixedStyles(): void {
                if (!this.cartColRight) return;

                // Kontrola media query - funguje pouze nad 992px
                if (window.innerWidth < 992) return;

                // Získej rozměry a pozici pravého sloupce
                const colRect: DOMRect = this.cartColRight.getBoundingClientRect();
                const colLeft: number = colRect.left;
                const colWidth: number = colRect.width;

                // Nastav CSS proměnné pro fixed pozici
                document.documentElement.style.setProperty('--cart-summary-left', `${colLeft}px`);
                document.documentElement.style.setProperty('--cart-summary-width', `${colWidth}px`);
            }

            private handleScroll(): void {
                if (!this.cartSummary || !this.cartFlex) return;

                // Kontrola media query - funguje pouze nad 992px
                if (window.innerWidth < 992) {
                    // Na mobilu odstraň všechny třídy a styly
                    this.cartSummary.classList.remove('is-fixed', 'is-bottom-stuck', 'is-scrolling-up');
                    (this.cartSummary as HTMLElement).style.transform = '';
                    return;
                }

                const scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;
                const navbarHeight: number = this.getNavbarHeight();

                // Detekce směru scrollování
                if (scrollTop > this.lastScrollTop) {
                    this.scrollDirection = 'down';
                } else if (scrollTop < this.lastScrollTop) {
                    this.scrollDirection = 'up';
                }
                this.lastScrollTop = scrollTop;

                // Získej pozice a rozměry
                const cartFlexRect: DOMRect = this.cartFlex.getBoundingClientRect();
                const cartFlexTop: number = cartFlexRect.top + scrollTop;
                const cartFlexBottom: number = cartFlexTop + cartFlexRect.height;

                const cartSummaryRect: DOMRect = this.cartSummary.getBoundingClientRect();
                const cartSummaryHeight: number = cartSummaryRect.height;

                // Získej původní pozici elementu v rámci flex containeru
                const cartSummaryOriginalTop: number = (this.cartSummary as HTMLElement).offsetTop;

                // Vypočítej kdy by se element měl začít "lepir" k navigaci
                const stickyStart: number = cartFlexTop + cartSummaryOriginalTop - navbarHeight;

                // Vypočítej kdy by se měl element přestat "lepit" (dosáhne konce containeru)
                const stickyEnd: number = cartFlexBottom - cartSummaryHeight - navbarHeight;

                // Odstraň všechny třídy
                this.cartSummary.classList.remove('is-fixed', 'is-bottom-stuck', 'is-scrolling-up');

                if (scrollTop < stickyStart) {
                    // Před sticky zónou - element zůstává na své původní pozici
                    (this.cartSummary as HTMLElement).style.transform = '';
                } else if (scrollTop >= stickyStart && scrollTop <= stickyEnd) {
                    // Ve sticky zóně - element se "lepí" k navigaci
                    this.cartSummary.classList.add('is-fixed');

                    if (this.scrollDirection === 'up') {
                        this.cartSummary.classList.add('is-scrolling-up');
                    }

                    // Element se drží pod navigací
                    (this.cartSummary as HTMLElement).style.transform = `translateY(${navbarHeight}px)`;
                    this.updateFixedStyles();
                } else {
                    // Za sticky zónou - element se zastaví na konci containeru
                    this.cartSummary.classList.add('is-bottom-stuck');

                    if (this.scrollDirection === 'up') {
                        this.cartSummary.classList.add('is-scrolling-up');
                    }

                    // Vypočítej finální pozici na konci containeru
                    const finalPosition: number = cartFlexBottom - cartFlexTop - cartSummaryHeight;
                    (this.cartSummary as HTMLElement).style.transform = `translateY(${finalPosition}px)`;
                }
            }
        }

        // Inicializace
        new StickyCartSummary();
    }
}
